import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {TaxSearchModel} from "../tax-search.model";
import {TaxSearchPageComponent} from "../tax-search-page/tax-search-page.component";
import {TaxEditPageComponent} from "../tax-edit-page/tax-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-tax-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(TaxSingleSelectEditControlComponent),
        provideSearchModel(TaxSearchModel)
    ]
})
export class TaxSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<TaxSearchModel> {
    constructor(model: TaxSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = TaxSearchPageComponent;
        this.extendedEditComponent = TaxEditPageComponent;
    }
}
